import { render, staticRenderFns } from "./application-form-4.vue?vue&type=template&id=5c620062&scoped=true&"
import script from "./application-form-4.vue?vue&type=script&lang=js&"
export * from "./application-form-4.vue?vue&type=script&lang=js&"
import style0 from "./application-form-4.vue?vue&type=style&index=0&id=5c620062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c620062",
  null
  
)

export default component.exports